import React, { useEffect, useState } from "react";
import Login from "../pages/Login/Login";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveSpecifications } from "./../reduxadmin/Actions/index";
import axios from "axios";
import { toast } from "react-toastify";

const Auth = (props) => {
  console.log("test7", props);
  const [authenticated, setAuthenticated] = useState(false);
  // const [decoded, setDecoded] = useState({});
  const dispatch = useDispatch();
  const totalNotification = useSelector(
    (state) => state.testRedux.specification,
  );
  const apiAddress = process.env.REACT_APP_SECRET;
  // const notificationData = useSelector()

  const [roleAuthenticated, setRoleAuthenticated] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    console.log(totalNotification);
    var decoded = {};
    console.log("p: " + props.role);
    const token = localStorage.getItem("gotasteadmintoken");

    if (token) {
      setAuthenticated(true);
    } else {
      navigate("/login");
    }
    if (token != null) {
      try {
        decoded = jwt_decode(token);
        if (decoded.UserRole == "Admin" && decoded.UserName == "Leo") {
          axios
            .get(
              apiAddress +
                "/api/RestaurantUserMapper/getbyuserid/" +
                decoded.UserId,
            )
            .then((response) => {
              if (response.data.length > 0) {
                var list = [];
                response.data.map((dt, i) => {
                  var obj = {
                    id: dt.restaurantId,
                    name: dt.restaurantName,
                    imgUrl: dt.imgUrl,
                    ulsHLfS: dt.isHomeCookToggle,
                    VSXnjMD: dt.isPreview,
                    FMlYe6C: dt.subsPlan,
                  };
                  list.push(obj);
                });
                localStorage.setItem(
                  "parentrestaurant",
                  JSON.stringify(list[0]),
                );
                toast.success(
                  "You are logged in as Admin." +
                    list[0].name +
                    " restaurant selected automatically  .",
                );
                localStorage.setItem(
                  "restaurantChanged",
                  "newRestaurantSelected",
                );
                console.log("response.data[0]", response.data[0]);
              }
            });
        }

        console.log(decoded);
      } catch (error) {
        console.log(error);
      }
    }

    console.log(totalNotification);
    props.role.map((dt, index) => {
      if (dt == decoded.UserRole) {
        setRoleAuthenticated(true);
      }
    });
  }, []);

  if (authenticated && roleAuthenticated) {
    return <div>{props.child}</div>;
  } else if (authenticated) {
    return (
      <div className="d-flex justify-content-center">
        <h3>Not Authenticated</h3>
      </div>
    );
  } else {
    return (
      <span>
        <Login />
      </span>
    );
  }
};

export default Auth;
